import React, { FunctionComponent } from 'react';

/**
 * Event Calendar Icon
 * Figma name: event_google_calendar
 */
export const EventCalendarIcon: FunctionComponent<
  React.PropsWithChildren<{ className?: string }>
> = ({ className }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 3.33268H15.8333C16.75 3.33268 17.5 4.08268 17.5 4.99935V16.666C17.5 17.5827 16.75 18.3327 15.8333 18.3327H4.16667C3.24167 18.3327 2.5 17.5827 2.5 16.666L2.50833 4.99935C2.50833 4.08268 3.24167 3.33268 4.16667 3.33268H5V1.66602H6.66667V3.33268H13.3333V1.66602H15V3.33268ZM4.16667 8.33268V16.666H15.8333V8.33268H4.16667ZM15.8333 6.66602H4.16667V4.99935H15.8333V6.66602ZM14.1667 10.8327H10V14.9993H14.1667V10.8327Z"
        fill="currentColor"
      />
    </svg>
  );
};
